import React from 'react';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import InfoText from '../../common/InfoText';
import {SettingOption} from './constants';
import {AFTER_X_HOURS, AFTER_X_MINUTES, AFTER_X_TIMES} from './constants';
type TriggerOptionalSettingsInputProps = {
	selectedSetting: SettingOption;
	counter?: number;
	duration?: number;
};
type Props = TriggerOptionalSettingsInputProps;

const TriggerOptionalSettingsInput = ({selectedSetting, counter, duration}: Props) => {
	const {t} = useTranslation();
	const getTooltip = () => {
		switch (selectedSetting) {
			case AFTER_X_TIMES:
				return tooltipCounter;

			case AFTER_X_MINUTES:
				return tooltipDurationMinutes;

			case AFTER_X_HOURS:
				return tooltipDurationHours;

			default:
				return tooltipNone;
		}
	};

	const tooltipNone = t('ruleengine.edit.rule.optionalSettingNoneInfoText', {
		defaultValue: 'Trigger on every datapoint change',
		counter
	});
	const tooltipCounter = t('ruleengine.edit.rule.optionalSettingAfterXTimesInfoText', {
		defaultValue: 'Trigger after datapoint changed {{counter}} times',
		counter
	});
	const tooltipDurationMinutes = t('ruleengine.edit.rule.optionalSettingAfterXTMinutesInfoText', {
		defaultValue: 'Trigger after datapoint matched the trigger condition for {{duration}} minute(s)',
		duration
	});
	const tooltipDurationHours = t('ruleengine.edit.rule.optionalSettingAfterXHoursInfoText', {
		defaultValue: 'Trigger after datapoint matched the trigger condition for {{duration}} hour(s)',
		duration: Math.floor((duration || 1) / 60)
	});
	const tooltip = getTooltip();
	return (
		<InfoText direction="right" bubble={tooltip}>
			&nbsp;
		</InfoText>
	);
};

export default TriggerOptionalSettingsInput;
